const steps = [
  "Diagnostic rapide du type de blocage (anti-fausse manœuvre, compas, crémone)",
  "Déblocage mécanique de la fenêtre sans forcer la menuiserie",
  "Réajustement ou remplacement de l'anti-fausse manœuvre",
  "Vérification et réglage du compas de manœuvre",
  "Contrôle de la crémone et des points de serrage",
  "Test d'ouverture en battant et en oscillation",
  "Explication des bons gestes pour éviter le blocage futur",
];

export default function OurUnlocking() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Intervention sur place
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Notre <span className="font-serif italic">déblocage</span> à domicile
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Quand une fenêtre oscillo-battant se bloque, c'est souvent une urgence. La fenêtre est coincée en position inclinée, impossible à fermer, et vous avez peur de la forcer. Notre intervention commence par un diagnostic : nous identifions le mécanisme bloqué (anti-fausse manœuvre, compas, crémone) sans jamais forcer sur la menuiserie. Le déblocage est mécanique et précis — nous utilisons les outils spécifiques à la marque de votre fenêtre pour libérer le mouvement sans endommager la fenêtre.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Une fois la fenêtre débloquée, nous réparons la cause du blocage. Si l'anti-fausse manœuvre est bloqué, nous le réajustons ou le remplaçons. Si le compas est usé, nous le changeons. Si la crémone est desserrée, nous la resserrons et vérifions les points de serrage. Tout est fait chez vous, en une seule visite, dans tout le Bas-Rhin.
          </p>
          <div className="space-y-4">
            {steps.map((step, i) => (
              <div key={i} className="flex items-start gap-4 bg-rose-50 rounded-2xl border border-rose-200 p-5 md:p-6">
                <div className="w-8 h-8 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <span className="text-plum-dark font-medium text-sm md:text-base">{step}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}